// 产品库表头数据
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          align: 'left',
          minWidth: 300,
          slot: 'productName',
          fixed: 'left',
          renderHeader: (h, params) => {
            return (
              <div>
                <span style="margin-right:4px">产品名称</span>
                <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip left0" transfer={true}>
                  <Icon style="color:#A8ADB7;fontSize:15px;" type="md-help-circle" />
                  <div slot="content">
                    <p>当供应商产品停售、禁售或无投保权限</p>
                    <p>时产品会标记为不可售</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '产品编码',
          key: 'productCode',
          align: 'center',
          minWidth: 100
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center',
          minWidth: 200
        },
        {
          title: '险种分类',
          key: 'themeName',
          align: 'center',
          minWidth: 120
        },
        {
          align: 'center',
          width: 120,
          render:(h, params)=> {
            let value = params.row.publishStatus;
            // if (value == 1 || !value || value == 0) {
            //   value = false;
            // } else if (value == 2) {
            //   value = true;
            // }
            // return <i-switch vModel={value} beforeChange={() => this.editStatus(params.row)} />;
            if(value == 1 || !value || value == 0){
              return <span>未上架</span>
            }else if (value == 2) {
              return <span>已上架</span>
            }
          },
          renderHeader: (h, params) => {
            return (
              <div>
                <span>是否上架</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;fontSize:15px;" type="md-help-circle" />
                  <div slot="content">
                    <p>是：业务员展业APP显示此产品</p>
                    <p>否：业务员展业APP不显示此产品</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
      ];
      // 非监管
      if (this.$units.superviseShowVal() && this.$units.pointAction('workbench_1')) {
        columns.push({
          key: 'source',
          align: 'center',
          minWidth: 100,
          renderHeader: (h, params) => {
            return (
              <div>
                <span>供应商</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;fontSize:15px;" type="md-help-circle" />
                  <div slot="content">
                    <p>该产品和哪个保司或机构合作签约的</p>
                    <p>可到供应商管理维护供应商</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        });
      }
      if(this.$units.pointAction('pro_2_5')) {
        columns.push({
          title: '服务费率',
          slot: 'fee',
          align: 'center',
          minWidth: 120,
          tooltip: true
        });
      }
      if (
        this.$units.pointAction('pro_2_5') ||
        this.$units.pointAction('pro_2_6') ||
        this.$units.pointAction('pro_2_7') ||
        this.$units.pointAction('pro_2_3')
      ) {
        columns.push({
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '140',
          fixed: 'right'
        });
      }
      this.columns = columns;
    }
  }
};
